// src/index.ts
export * from "@react-spring/web";
//# sourceMappingURL=react-spring.modern.mjs.map